<template>
  <generic-modal :title="$t('attentions')" ref="generic_modal" :is_wide="true">
    <div class="form">
      <div class="columns">
        <div class="column is-one-fifth">
          <div class="field">
            <label class="label">{{ $t("quantity") }}</label>
            <div class="control">
              <input
                class="input"
                type="text"
                v-model="attention.quantity"
                ref="quantity_input"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <generic-dropdown
              :title="$t('product')"
              :placeholder="$t('select product')"
              url="/product/catalog"
              :is_multiple="false"
              name_field="name"
              value_field="product_id"
              @selected="set_product"
            />
          </div>
        </div>
        <div class="column is-one-fifth">
          <div class="field">
            <label class="label">{{ $t("price") }}</label>
            <div class="control">
              <input class="input" type="text" v-model="attention.price" />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="button is-rounded is-primary" @click="add_attention">
            <span class="icon">
              <i class="fa fa-plus"></i>
            </span>
            <span>{{ $t("add") }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="title is-5">{{ $t("attentions") }}</div>
    <div class="table-container">
      <table class="table is-fullwidth">
        <thead>
          <tr>
            <th>{{ $t("date") }}</th>
            <th>{{ $t("quantity") }}</th>
            <th>{{ $t("product") }}</th>
            <th>{{ $t("price") }}</th>
            <th>{{ $t("options") }}</th>
            <!-- <th>{{ $t("total") }}</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(attention, aidx) in attentions" :key="aidx">
            <td>{{ format_date_time(attention.create_date) }}</td>
            <td>{{ attention.quantity }}</td>
            <td>{{ attention.product.name }}</td>
            <td>{{ format_currency(attention.price) }}</td>
            <td>
              <div class="buttons">
                <div
                  class="button is-small is-danger"
                  @click="delete_attention(attention)"
                >
                  <span class="icon">
                    <i class="fa fa-trash"></i>
                  </span>
                </div>
              </div>
            </td>
            <!-- <td>{{ attention.total }}</td> -->
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td>{{ $t("total") }}</td>
            <td>{{ format_currency(total) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    <!-- <pre>{{ attentions }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error" v-html="error"></div>
    <template v-slot:footer>
      <!-- <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button
        class="button is-danger is-rounded"
        @click="remove"
        v-if="meta.uuid"
      >
        <span class="icon">
          <i class="fa fa-trash"></i>
        </span>
        <span>{{ $t("delete") }}</span>
      </button> -->
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("close") }}</span>
      </button>
    </template>
    <patient-modal ref="patient_modal" />
    <team-modal ref="team_modal" />
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  del,
  confirm_deletion_dialog,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_date_time,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericCalendar from "@/components/generic_calendar/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import PatientModal from "../patient_datatable/patient_modal/Index.vue";
import TeamModal from "../team_datatable/team_modal/Index.vue";
import moment from "moment";

export default {
  name: "AppointmentModal",
  components: {
    GenericModal,
    GenericCalendar,
    GenericDropdown,
    PatientModal,
    TeamModal,
  },
  data() {
    return {
      hospitalization_uuid: "",
      attention: {
        settings: {},
      },
      attentions: [],
      error: "",
    };
  },
  computed: {
    // is_form_invalid() {
    //   let v = this;
    //   return false;
    //   // return !v.meta.patient_id || !v.meta.start_date;
    // },
    total() {
      let v = this;
      if (v.attentions && v.attentions.length) {
        return v.attentions.reduce((acc, cur) => acc + Number(cur.price), 0);
      } else {
        return 0;
      }
    },
  },
  methods: {
    format_date_time,
    format_currency,
    refresh() {
      let v = this;
      get("/patient/hospitalization/attention", {
        uuid: v.hospitalization_uuid,
      })
        .then((attentions) => {
          v.attentions = attentions;
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(hospitalization_uuid) {
      let v = this;
      v.set_initial_state();

      if (hospitalization_uuid) {
        v.hospitalization_uuid = hospitalization_uuid;
        // v.uuid = product_uuid;
        v.refresh();
        v.$refs.generic_modal.show_modal();
      } else v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.attention = {
        settings: {},
      };
      v.error = "";

      v.$refs.quantity_input.focus();
      // v.uuid = "";
    },
    set_product(product) {
      let v = this;
      if (product) v.attention.product_id = product.product_id;
    },
    add_attention() {
      let v = this;
      let data = {
        ...v.attention,
        hospitalization_uuid: v.hospitalization_uuid,
      };
      put("/patient/hospitalization/attention", data)
        .then((attention) => {
          v.set_initial_state();
          v.refresh();
          // v.$emit("refresh");
          // v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    delete_attention(attention) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete attention?"),
        v,
        () => {
          del("/patient/hospitalization/attention", {
            uuid: attention.uuid,
          })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              v.error = generate_error_message_text(error);
            });
        }
      );
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
